export default "__VITE_ASSET__B46_5f$A__"